<template>
  <div class="giftBeer">
    <div class="n_height"></div>
    <!-- <div class="n_top">注：单次最低提999瓶</div> -->
    <van-list
      class="goods_list"
      v-model="loading"
      @load="onLoad"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      finished-text="没有更多了"
    >
      <div class="goods_item" v-for="(item,index) in deliveryList" :key="index">
        <div v-for="titem in item.detail_list" :key="titem.id">
          <div class="n_content">
            <p>{{item.title}}--{{item.id}}-</p>
            <p>余{{titem.plus_num}}</p>
          </div>
          <div class="top">
            <div class="left">
              <img :src="titem.images?titem.images:imgPath+'yj_defatult.png'" alt />
            </div>
            <div class="right">
              <div class="right_title">{{titem.goods_name}}</div>
              <div class="right_bottom">
                <van-stepper class="num" v-model="titem.num" integer />
              </div>
            </div>
          </div>
        </div>
        <div class="n_flex">
          <div></div>
          <van-button class="goods_btn" @click="takeDelivery(item,index)" round type="info">提货</van-button>
        </div>
      </div>
    </van-list>
    <toastMune v-if="messageFile!=''" :isToast="isToast" :message="messageFile"></toastMune>
  </div>
</template>

<script>
import { Toast } from 'vant'
import toastMune from '../components/toast.vue'
document.body.style.backgroundColor = '#f7f8fa'
export default {
  components: { toastMune },
  name: 'giftGoodsBeer',
  data() {
    return {
      // 数量选择器绑定数据的数组
      arrList: [],
      // 请求到的提货数据
      deliveryList: [],
      error: false,
      loading: false,
      finished: false,
      value: 1,
      // 提货数据条数
      count: 8,
      // 请求数据对象
      queryObj: {
        page: 0,
        limit: 10,
        enable: 1,
      },
      // 提货节流
      isDelivering: false,
      isToast: false,
      messageFile: '',
    }
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    // 点击提货
    takeDelivery(titem, index) {
      if (
        this.deliveryList[index].detail_list[0].num %
          this.deliveryList[index].detail_list[0].dabao_num !=
        0
      ) {
        this.isToast = true
        this.messageFile =
          '商品不满足打包数，请输入' +
          this.deliveryList[index].detail_list[0].dabao_num +
          '或' +
          this.deliveryList[index].detail_list[0].dabao_num +
          '倍数'
        setTimeout(() => {
          this.isToast = false
        }, 1500)
        return
      }
      if (this.isDelivering) return
      this.isDelivering = true
      try {
        if (this.deliveryList[index].detail_list[0].status !== 1) {
          return this.$toast.fail('当前礼包卡商品不可用')
        } else {
          localStorage.setItem('spec_id', titem.id)
          localStorage.setItem(
            'num',
            this.deliveryList[index].detail_list[0].num
          )
          localStorage.setItem('type', 'pick_up')
          this.$router.push({
            path: './ConfirmOrder',
          })
        }
        //调用提货接口...
      } catch (err) {
        this.$toast.fail('提货失败，请稍后重试')
      } finally {
        this.isDelivering = false
      }
    },
    // 列表加载
    onLoad() {
      this.queryObj.page++
      this.getDeliveryList()
    },
    // 获取提货列表
    async getDeliveryList() {
      let data = await this.http(
        'ClientOrder.getTransferDetailList',
        this.queryObj
      )
      this.deliveryList = [...this.deliveryList, ...data.content.list]
      console.log(data.content.list.length == 0)
      this.loading = false
      this.finished = this.deliveryList.length == data.content.count
    },
  },
  created() {
    // this.getDeliveryList()
  },
}
</script>

<style scoped lang='scss'>
.giftBeer {
  padding: 0 20px;
  .goods_list {
    .goods_item {
      background-color: #fff;
      border-radius: 14px;
      padding: 30px;
      margin-top: 21px;
      .top {
        display: flex;

        .left {
          width: 140px;
          height: 140px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 30px;
          height: 140px;
          width: 520px;
          .right_title {
            width: 420px;
            height: 28px;
            padding: 10px 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 28px;
          }
          .right_bottom {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
          }
        }
      }
      .bottom_tips {
        flex-wrap: wrap;
        width: 238px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ee0a24;
        margin: 30px 0 0 16px;
      }
    }
  }
}
.n_flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.goods_btn {
  width: 168px;
  height: 68px;
  background: #ee0a24;
  border-radius: 34px;
}
.n_top {
  margin-top: 20px;
  width: 710px;
  height: 80px;
  background: #fbe7e7;
  border-radius: 14px;
  font-size: 28px;
  color: #f0240e;
  box-sizing: border-box;
  padding: 26px 30px;
}
.n_height {
  height: 20px;
}
.n_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
  color: #333333;
}
</style>